export const BASE_PATH = `${environment.sportBetsRootUrl}`;

window.BASE_PATH = BASE_PATH;

export const PATHS = {
    HOME: "/",
    LIVE: "/live",
    PREMATCH: "/kurzy",
    TICKET: "/tiket",
    TICKET_SETTINGS: "/tiket/nastaveni",
    MY_TICKETS: "/moje-tikety",
    SEARCH: "/vyhledavani",
    STATS: "/statistiky",
};
